import { ANIMATION_VARIATIONS_FRAMES } from '@/map-phaser-new/constants'
import type { AnimationsData } from '@/map-phaser-new/interfaces'

export const cableCarRightToUpAnimations: AnimationsData[] = [
  {
    animationCreationData: {
      animationName: 'cableCarRightToUpAnimations1',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '25',
      delay: 0,
      duration: 500,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 3,
        end: 8,
        zeroPad: 2,
      },
    },
  },
]
